import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Images } from 'lucide-react';
import { apiClient, resolveFileUrl } from '../services/api';
import { Layout } from './Home';

const PublicGalleriesListPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient
      .get('/galleries/public')
      .then((r) => setItems(r.data.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-12 lg:py-20">
        <div className="text-xs font-semibold tracking-[0.3em] text-[#0f5c3d] uppercase">Newsroom</div>
        <h1 className="mt-2 text-4xl sm:text-5xl lg:text-6xl text-[#0b1a2e]"
            style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}>
          Galleries
        </h1>
        <p className="mt-3 text-[#0b1a2e]/70 max-w-2xl">
          Moments from across the Emerald Corporates world — site visits, launches, delegations and beyond.
        </p>

        {loading ? (
          <div className="mt-16 text-center text-[#0b1a2e]/60">
            <Loader2 className="w-6 h-6 animate-spin inline mr-2" /> Loading galleries…
          </div>
        ) : items.length === 0 ? (
          <div className="mt-16 text-center text-[#0b1a2e]/50 py-24 border-2 border-dashed border-[#0f5c3d]/20 rounded-2xl">
            <Images className="w-10 h-10 mx-auto mb-3 opacity-40" />
            No galleries published yet.
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((g) => (
              <Link
                key={g.gallery_id}
                to={`/galleries/${g.gallery_id}`}
                data-testid={`public-gallery-card-${g.gallery_id}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition"
              >
                <div className="aspect-[4/3] bg-[#0f5c3d]/5 relative overflow-hidden">
                  {g.cover_url ? (
                    <img
                      src={resolveFileUrl(g.cover_url)}
                      alt={g.title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-[#0f5c3d]/30">
                      <Images className="w-14 h-14" />
                    </div>
                  )}
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-widest text-[#0f5c3d]">
                    {g.item_count || 0} items
                  </div>
                </div>
                <div className="p-5">
                  <div className="text-xs font-semibold tracking-widest text-[#0f5c3d] uppercase mb-1">Gallery</div>
                  <div className="text-xl text-[#0b1a2e]" style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}>
                    {g.title}
                  </div>
                  {g.description && (
                    <div className="mt-2 text-sm text-[#0b1a2e]/60 line-clamp-2">{g.description}</div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default PublicGalleriesListPage;
